import { App } from './app/app.js';
import './scss/index.scss';
// TODO chat nikolay when all done and pushed to QA for compliance test
const app = new App('body');
app.init();
